exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".bg-wringers-info{\n    /* background-color: #343a40!important; */\n    background-color: #7F7F7F!important;\n    /* background: linear-gradient(to right,#7F7F7F,red); */\n\n}\n\n.social-icons{\n    width: 50px;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./ClientApp/app/components/member-faq/member-faq.component.css
// module id = 420
// module chunks = 0